module.exports = __webpack_public_path__ + "media/images/meta/admin/apple-touch-icon-b62e0c59bddb8c0be022a84021451bec.png";